import axios from "axios";
import {
    setUserLoading, setRewardsLoading, setNeedsBadges, setBadgesLoading, setUserEmail, setUserName, setRewardSections, setVotingSections, setGamesSections,
    setBadgeSections, setBadgeCounts, setCTBadgeCounts, setCTBadgeSections, setRedeemRewardLoading, setRedeemReward, setRedeemRewardError, setCtEncryptedId,
    setHasVoting, setPollSubmissionSuccess, setPollSubmissionError, setPollSubmissionResults, setQuizSubmissionSuccess, setQuizSubmissionError,
    setSurveySubmissionSuccess, setSurveySubmissionError, setMemberSince, setFavoriteTeams, setIsVIP, setNeedsCTBadges, setWalletData,
    setChallengesLoading, setChallengeData, setJoiningChallenge, setShowNotification, setNotificationBody, setUserGuid, setUserType,
    setEventCheckin,
} from './dataSlice';

var BASE_API_URL = document.location.origin;
if (process.env.REACT_APP_BASE_API_URL) {
    BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
}

var ENV = "prod";
if (process.env.REACT_APP_ENV) {
    ENV = process.env.REACT_APP_ENV.toLowerCase();
} else if (BASE_API_URL.includes('-uat')) {
    ENV = "uat";
} else if (BASE_API_URL.includes('-qa')) {
    ENV = "qa";
} else if (BASE_API_URL.includes('-dev')) {
    ENV = "dev";
}

export const resetLocalStorage = (tabSelected) => {
    localStorage.setItem('isLoggedIn', '0');
    localStorage.setItem('fromVoting', '0');
    localStorage.setItem('fromWallet', '0');
    localStorage.setItem('confetti', '[]');
    localStorage.setItem('tabSelected', tabSelected);
    localStorage.removeItem('hasVoting');
    // badges
    localStorage.setItem('ctBadgeCounts', '');
    localStorage.setItem('ctBadgeSections', '');
    // rewards
    localStorage.setItem('redeemedReward', '');
    localStorage.setItem('redeemedRewardError', '');
    // sections
    localStorage.setItem('badgeSections', '[]');
    localStorage.setItem('ctBadgeSections', '[]');
    localStorage.setItem('challengeData', '[]');
    localStorage.setItem('gamesSections', '[]');
    localStorage.setItem('rewardSections', '[]');
    localStorage.setItem('votingSections', '[]');
    // user
    localStorage.setItem('ctEncryptedId', '');
    localStorage.setItem('earnedBadges', '[]');
    localStorage.setItem('favoriteTeams', '[]');
    localStorage.setItem('futureBadges', '[]');
    localStorage.setItem('isVIP', '');
    localStorage.setItem('memberSince', '');
    localStorage.setItem('phoneNumber', '');
    localStorage.setItem('userEmail', '');
    localStorage.setItem('userGuid', '');
    localStorage.setItem('userName', '');
    localStorage.setItem('userType', '');

    const queryParams = new URLSearchParams(window.location.search);
    const webview = queryParams.get("webview") ?? "false";
    localStorage.setItem('webview', webview);

    console.log("setItem href:", document.location.href);
    localStorage.setItem('href', document.location.href);
};

const getWebviewPath = () => {
    let webview = localStorage.getItem('webview');
    let webviewPath = "";
    if (webview && webview.toLowerCase() === 'true') {
        webviewPath = "webview/";
    }
    console.log("webviewPath:", webviewPath);
    return webviewPath;
};

const doMaintenance = () => {
    let maintenanceUrl = "https://www.nba.com/id/maintenance";
    console.log("maintenanceUrl:", maintenanceUrl);
    window.location.replace(maintenanceUrl);
};

const doLogin = (tabSelected) => {
    const fromVoting = localStorage.getItem('fromVoting');
    const fromWallet = localStorage.getItem('fromWallet');
    console.log("fromVoting:", fromVoting);
    console.log("fromWallet:", fromWallet);

    if (fromWallet && fromWallet === "1") {
        resetLocalStorage("wallet");
    } else {
        resetLocalStorage(tabSelected);
    }

    const webviewPath = getWebviewPath();
    const envPath = (ENV === "prod") ? "" : "-" + ENV;

    let loginPathUrl = `https://www${envPath}.nba.com/${webviewPath}id${window.location.search}`;

    const queryParams = new URLSearchParams(window.location.search);
    const isUser = queryParams.get("u");
    console.log("u:", isUser);

    if ((isUser && isUser === "1") || (fromVoting && fromVoting === "1") || (fromWallet && fromWallet === "1")) {
        loginPathUrl = `https://www${envPath}.nba.com/account/sign-in?redirect-to-membership-hub${window.location.search.replace("?", "&")}`;
    }

    console.log("loginPathUrl:", loginPathUrl);

    window.location.replace(loginPathUrl);
};

export const validateCookie = async (tabSelected) => {
    return new Promise((resolve) => {
        const webCookieTokenUrl = (ENV === "prod") ? "https://identity.nba.com/api/v1/web/cookie/token" : `https://identity-${ENV}.nba.com/${ENV}/web/cookie/token`;
        axios
            .get(webCookieTokenUrl, { withCredentials: true })
            .then((res) => {
                if (res.data && res.data.status && res.data.status !== "success") {
                    resetLocalStorage(tabSelected);
                    const webviewPath = getWebviewPath();
                    const envPath = (ENV === "prod") ? "" : "-" + ENV;
                    window.location.replace(`https://www${envPath}.nba.com/${webviewPath}id`);
                    resolve(false);
                }
                resolve(true);
            })
            .catch((err) => {
                console.log(err);
                resetLocalStorage(tabSelected);
                const webviewPath = getWebviewPath();
                const envPath = (ENV === "prod") ? "" : "-" + ENV;
                window.location.replace(`https://www${envPath}.nba.com/${webviewPath}id`);
                resolve(false);
            });
    });
};

export const validateUser = (tabSelected) => {
    return async (dispatch) => {
        console.log("validateUser");

        dispatch(setUserLoading(true));

        const isLoggedIn = localStorage.getItem('isLoggedIn');
        console.log("isLoggedIn:", isLoggedIn);

        const userEmail = localStorage.getItem('userEmail');
        console.log("email:", userEmail);

        console.log("location.href:", document.location.href);
        console.log("location.search:", document.location.search);

        axios
            .get(`${BASE_API_URL}/api/validate/user`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data && res.data.data.profile) {
                    resetLocalStorage(tabSelected);
                    const givenName = res.data.data.profile.givenName;
                    const familyName = res.data.data.profile.familyName;
                    const favoriteTeams = res.data.data.profile.favoriteTeams;
                    const userEmail = res.data.data.profile.email;
                    const vipType = res.data.data.profile.vipType;
                    const userGuid = res.data.data.profile.alternateIds.NBACIAMGUID;
                    const userSubs = res.data.data.subscriptions;

                    localStorage.setItem('userName', JSON.stringify({ familyName: familyName, givenName: givenName }));
                    dispatch(setUserName({ familyName: familyName, givenName: givenName }));
                    localStorage.setItem('isVIP', !!vipType);
                    dispatch(setIsVIP(!!vipType));

                    const userType = !!vipType ? "vip" : Object.keys(userSubs).length > 0 ? "subscriber" : "free member";
                    localStorage.setItem('userType', userType);
                    dispatch(setUserType(userType));

                    dispatch(setFavoriteTeams(favoriteTeams));
                    localStorage.setItem('userEmail', userEmail);
                    dispatch(setUserEmail(userEmail));
                    localStorage.setItem('userGuid', userGuid);
                    dispatch(setUserGuid(userGuid));

                    const isLoggedIn = localStorage.getItem('isLoggedIn');
                    console.log("isLoggedIn:", isLoggedIn);
                    localStorage.setItem('isLoggedIn', '1');

                    if (res.data.data.ctWidgetAuth === "maintenance") {
                        doMaintenance();
                    } else {
                        let ctEncryptedId = res.data.data.ctWidgetAuth.encrypted_id;
                        setCtEncryptedId(ctEncryptedId);
                        console.log("ctEncryptedId:", ctEncryptedId);
                        localStorage.setItem('ctEncryptedId', ctEncryptedId);
                    }
                } else if (res && res.data && res.data.status === "success" && res.data.data && res.data.data.ctWidgetAuth === "maintenance") {
                    doMaintenance();
                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                } else {
                    doLogin(tabSelected);
                }
            })
            .catch((err) => {
                console.log(err);

                if (err.response && err.response.data && err.response.data.status === "error" && err.response.data.data === "maintenance") {
                    doMaintenance();
                } else {
                    doLogin(tabSelected);
                }
            })
            .finally(() => {
                dispatch(setUserLoading(false));
            });
    };
};

export const getRewardSections = (tabSelected) => {
    return async (dispatch) => {
        console.log("getRewardSections");
        dispatch(setRewardsLoading(true));
        let ctEncryptedId = localStorage.getItem("ctEncryptedId");
        let eid = "";
        if (ctEncryptedId) {
            eid = `?eid=${ctEncryptedId}`;
        }

        //get user rewards
        axios
            .get(`${BASE_API_URL}/api/rewards${eid}`)
            .then((res) => {
                if (res && res.data && res.data.status === "success") {
                    let userRewards = { ...res.data.data };

                    const DANGEROUS_KEYS = ["__proto__", "constructor", "prototype"];

                    Object.entries(userRewards).forEach(([key, _]) => {
                        if (DANGEROUS_KEYS.includes(key)) {
                            return; // Skip dangerous keys entirely
                        }

                        // Sort Rewards
                        userRewards[key].rewards = userRewards[key].rewards.sort((a, b) => {
                            let a_rank = parseInt(a.extra_data.reward_rank);
                            if (isNaN(a_rank)) { a_rank = Number.MAX_SAFE_INTEGER; }
                            let b_rank = parseInt(b.extra_data.reward_rank);
                            if (isNaN(b_rank)) { b_rank = Number.MAX_SAFE_INTEGER; }

                            if (a_rank === b_rank) {
                                if (a.date_start && b.date_start) {
                                    let a_start = parseInt(a.date_start);
                                    if (isNaN(a_start)) { a_start = 0; }
                                    let b_start = parseInt(b.date_start);
                                    if (isNaN(b_start)) { b_start = 0; }
                                    return b_start - a_start;
                                }
                            }

                            return a_rank - b_rank;
                        });
                    });

                    dispatch(setRewardsLoading(false));
                    localStorage.setItem('rewardSections', JSON.stringify(userRewards));
                    dispatch(setRewardSections(userRewards));

                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                } else if (res && res.data && res.data.status === "error" && res.data.errorCodes && (res.data.errorCodes.includes("INVALID_COOKIE") || res.data.errorCodes.includes("INVALID_SESSION"))) {
                    doLogin(tabSelected);
                }
                if (ENV !== "prod") {
                    console.log("qa updated REWARDS", res);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.log("qa updated REWARDS ERROR", err);
                }
            });
    };
};

export const redeemReward = (reward, phoneNumber) => {
    return async (dispatch) => {
        console.log("redeemReward - reward ID:", reward.id);
        dispatch(setRedeemRewardLoading(true));
        let body;
        if (phoneNumber) {
            body = {
                phone_number: phoneNumber
            }
        }
        console.log("redeemReward body: ", body);
        //get all rewards
        axios
            .post(`${BASE_API_URL}/api/reward/${reward.id}`, body)
            .then((res) => {
                console.log("Removing redeemedReward and redeemedRewardError from local storage: ");
                localStorage.setItem("redeemedReward", "");
                localStorage.setItem("redeemedRewardError", "");
                dispatch(setRedeemReward([]));
                dispatch(setRedeemRewardError([]));
                if (res && res.data) {
                    if (res.data.status === "success") {
                        dispatch(setRedeemRewardLoading(false));
                        localStorage.setItem("redeemedReward", JSON.stringify(res.data));
                        dispatch(setRedeemReward(res.data));

                        // Modal Analytics
                        if (window._satellite) {
                            let data = {
                                contentTitle: reward.title,
                                contentID: reward.id,
                            };
                            window._satellite.track("benefit-redemption", data);
                            console.log("window._satellite.track:benefit-redemption:", data);
                        }
                    } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                        doMaintenance();
                    } else if (res.data.status === "error") {
                        dispatch(setRedeemRewardLoading(false));
                        localStorage.setItem("redeemedRewardError", JSON.stringify(res.data));
                        dispatch(setRedeemRewardError(res.data));
                        console.log("status=error REDEEM REWARD", res.data);

                        // Modal Analytics
                        if (window._satellite) {
                            let data = {
                                modalName: "nba:membership-hub:benefits-detail",
                                contentTitle: reward.title,
                                contentID: reward.id,
                                contentType: "benefit",
                                errorMessage: res.data.data && res.data.data.message ? res.data.data.message : JSON.stringify(res.data)
                            };
                            window._satellite.track("modal-display", data);
                            console.log("window._satellite.track:modal-display:", data);
                        }
                    }
                }
                console.log("qa updated REDEEM REWARD", res);
            })
            .catch((err) => {
                console.log("qa updated REDEEM REWARD ERROR", err);
            });
    };
};

export const getWallet = (tabSelected) => {
    return async (dispatch) => {
        console.log("getWallet");
        // get wallet
        axios
            .get(`${BASE_API_URL}/api/walletid`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    dispatch(setWalletData(res.data.data));
                    dispatch(setMemberSince(res.data.data.member_since));
                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                } else if (res && res.data && res.data.status === "error" && res.data.errorCodes && (res.data.errorCodes.includes("INVALID_COOKIE") || res.data.errorCodes.includes("INVALID_SESSION"))) {
                    doLogin(tabSelected);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.log("qa get wallet ERROR", err);
                }
            });
    };
};

export const getBadges = (tabSelected) => {
    return async (dispatch) => {
        console.log("getBadges");
        // get badges
        dispatch(setBadgesLoading(true));
        axios
            .get(`${BASE_API_URL}/api/badges`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    dispatch(setNeedsBadges(false));
                    dispatch(setBadgesLoading(false));

                    localStorage.setItem("badgeSections", JSON.stringify(res.data.data.sections));
                    dispatch(setBadgeSections(res.data.data.sections));

                    localStorage.setItem("badgeCounts", JSON.stringify(res.data.data.counts));
                    dispatch(setBadgeCounts(res.data.data.counts));
                    dispatch(setMemberSince(res.data.data.member_since));
                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                } else if (res && res.data && res.data.status === "error" && res.data.errorCodes && (res.data.errorCodes.includes("INVALID_COOKIE") || res.data.errorCodes.includes("INVALID_SESSION"))) {
                    doLogin(tabSelected);
                }
                if (ENV !== "prod") {
                    console.log("qa updated BADGES", res);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.log("qa updated BADGES ERROR", err);
                }
            });
    };
};

export const getCTBadges = (tabSelected) => {
    return async (dispatch) => {
        console.log("getBadges");
        // get badges
        dispatch(setBadgesLoading(true));
        axios
            .get(`${BASE_API_URL}/api/ct-badges`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    dispatch(setNeedsCTBadges(false));
                    dispatch(setBadgesLoading(false));

                    localStorage.setItem("ctBadgeSections", JSON.stringify(res.data.data.sections));
                    dispatch(setCTBadgeSections(res.data.data.sections));

                    localStorage.setItem("ctBadgeCounts", JSON.stringify(res.data.data.counts));
                    dispatch(setCTBadgeCounts(res.data.data.counts));
                    dispatch(setMemberSince(res.data.data.member_since));
                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                } else if (res && res.data && res.data.status === "error" && res.data.errorCodes && (res.data.errorCodes.includes("INVALID_COOKIE") || res.data.errorCodes.includes("INVALID_SESSION"))) {
                    doLogin(tabSelected);
                }
                if (ENV !== "prod") {
                    console.log("qa updated CT BADGES", res);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.log("qa updated CT BADGES ERROR", err);
                }
            });
    };
};

export const getBadgeById = async (badgeId) => {
    console.log("getBadgeById");
    try {
        let res = await axios.get(`${BASE_API_URL}/api/badges/${badgeId}`);
        if (res && res.data && res.data.status === "success" && res.data.data) {
            return res.data.data;
        }
    } catch (error) {
    }
    return null;
};

export const getVoting = () => {
    return async (dispatch) => {
        console.log("getVoting");
        axios
            .get(`${BASE_API_URL}/api/voting`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data) {

                    let votingSections = res.data.data;

                    console.log("votingSections:", votingSections)
                    localStorage.setItem("votingSections", JSON.stringify(votingSections));
                    dispatch(setVotingSections(votingSections));

                    if (votingSections["7"] && votingSections["7"].rewards && votingSections["7"].rewards.length > 0) {
                        dispatch(setHasVoting(true));
                    }
                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                }
            })
            .catch((error) => {
                console.log("getVoting|Error:", error);
            });
    };
};

export const getGames = () => {
    return async (dispatch) => {
        console.log("getGames");

        //get public rewards
        let publicRewards;
        try {
            publicRewards = await axios.get(`${BASE_API_URL}/api/publicrewards`);
        } catch (e) {
            console.log("public rewards unavailable: ", e);
        }

        axios
            .get(`${BASE_API_URL}/api/games`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    let gamesSections = res.data.data;

                    if (publicRewards && publicRewards.data.data["6"]) {
                        const publicRewardSection = publicRewards.data.data["6"];
                        gamesSections.rewards = gamesSections.rewards.concat(publicRewardSection.rewards);
                    }

                    console.log("gamesSections:", gamesSections)
                    localStorage.setItem("gamesSections", JSON.stringify(gamesSections));
                    dispatch(setGamesSections(gamesSections));

                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                }
            })
            .catch((error) => {
                console.log("getGames|Error:", error);
            });
    };
};

export const getChallenges = (tabSelected) => {
    return async (dispatch) => {
        console.log("getChallenges");
        // get challenges
        axios
            .get(`${BASE_API_URL}/api/challenges`)
            .then((res) => {
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    localStorage.setItem("challengeData", JSON.stringify(res.data.data.challenges));
                    dispatch(setChallengeData(res.data.data.challenges));
                    dispatch(setChallengesLoading(false));
                } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                    doMaintenance();
                } else if (res && res.data && res.data.status === "error" && res.data.errorCodes && (res.data.errorCodes.includes("INVALID_COOKIE") || res.data.errorCodes.includes("INVALID_SESSION"))) {
                    doLogin(tabSelected);
                }
                if (ENV !== "prod") {
                    console.info("Updated Challenges", res);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.error("updated CHALLENGES ERROR", err);
                }
            });
    };
};

export const joinChallenge = activity_id => {
    return async (dispatch) => {
        console.log("joinChallenge");
        // join challenge
        axios
            .post(`${BASE_API_URL}/api/join-challenge`, { activity_id })
            .then((res) => {
                if (ENV !== "prod") {
                    console.info("Joining challenge: " + activity_id, res);
                }
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    dispatch(setJoiningChallenge(false));
                    dispatch(setShowNotification(true));
                    dispatch(setNotificationBody(activity_id));
                    setTimeout(() => dispatch(setShowNotification(false)), 7000);
                } else if (res && res.data && res.data.status === "error") {
                    console.error("join challenge error: ", res.data);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.error("JOIN CHALLENGE ERROR", err);
                }
            });
    };
};

export const doEventCheckin = activity_id => {
    return async (dispatch) => {
        console.log("doEventCheckin");
        // event checkin
        axios
            .post(`${BASE_API_URL}/api/join-challenge`, { activity_id })
            .then((res) => {
                if (ENV !== "prod") {
                    console.info("doEventCheckin: " + activity_id, res);
                }
                if (res && res.data && res.data.status === "success" && res.data.data) {
                    dispatch(setEventCheckin(true));
                } else if (res && res.data && res.data.status === "error") {
                    console.error("doEventCheckin error: ", res.data);
                }
            })
            .catch((err) => {
                if (ENV !== "prod") {
                    console.error("doEventCheckin ERROR", err);
                }
            });
    };
};

export const submitPoll = payload => {
    return async dispatch => {
        console.log("submitPoll - payload:", payload);
        dispatch(setRedeemRewardLoading(true));

        // Submit poll payload
        axios
            .post(`${BASE_API_URL}/api/voting/poll`, payload)
            .then(res => {
                if (res && res.data) {
                    if (res.data.status === "success") {
                        dispatch(setRedeemRewardLoading(false));
                        dispatch(setPollSubmissionSuccess(true));
                        dispatch(setPollSubmissionError(""));
                        dispatch(setPollSubmissionResults(res.data.data));
                    } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                        doMaintenance();
                    } else if (res.data.status === "error") {
                        dispatch(setRedeemRewardLoading(false));
                        dispatch(setPollSubmissionSuccess(false));
                        dispatch(setPollSubmissionError(res.data.data.message));
                        console.log("status=error Submit Poll", res.data.data.message);
                    }
                }
                dispatch(setVotingSections([]));
                console.log("qa updated SUBMIT POLL", res);
            })
            .catch(res => {
                console.log("qa updated SUBMIT POLL ERROR", res.data.data.message);
            });
    };
};

export const submitQuiz = payload => {
    return async dispatch => {
        console.log("submitQuiz - payload:", payload);
        dispatch(setRedeemRewardLoading(true));

        // Submit poll payload
        axios
            .post(`${BASE_API_URL}/api/voting/quiz`, payload)
            .then(res => {
                console.log("aa", res);
                if (res && res.data) {
                    if (res.data.status === "success") {
                        dispatch(setRedeemRewardLoading(false));
                        dispatch(setQuizSubmissionSuccess(true));
                        dispatch(setQuizSubmissionError(null));
                    } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                        doMaintenance();
                    } else if (res.data.status === "error") {
                        dispatch(setRedeemRewardLoading(false));
                        dispatch(setQuizSubmissionSuccess(false));
                        dispatch(setQuizSubmissionError(res.data.data.message));
                        console.log("status=error Submit Quiz", res.data.data.message);
                    }
                }
                dispatch(setVotingSections([]));
                console.log("qa SUBMIT QUIZ", res);
            })
            .catch(res => {
                console.log("qa SUBMIT QUIZ ERROR", res.data.data.message);
            });
    };
};

export const submitSurvey = payload => {
    return async dispatch => {
        console.log("submitSurvey - payload:", payload);
        dispatch(setRedeemRewardLoading(true));

        // Submit poll payload
        axios
            .post(`${BASE_API_URL}/api/voting/survey`, payload)
            .then(res => {
                if (res && res.data) {
                    if (res.data.status === "success") {
                        dispatch(setRedeemRewardLoading(false));
                        dispatch(setSurveySubmissionSuccess(true));
                        dispatch(setSurveySubmissionError(false));
                    } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                        doMaintenance();
                    } else if (res.data.status === "error") {
                        dispatch(setRedeemRewardLoading(false));
                        dispatch(setSurveySubmissionSuccess(false));
                        dispatch(setSurveySubmissionError(res.data.data.message));
                        console.log("status=error Submit Survey", res.data.data.message);
                    }
                }
                dispatch(setVotingSections([]));
                console.log("qa updated SUBMIT SURVEY", res);
            })
            .catch(res => {
                console.log("qa updated SUBMIT SURVEY ERROR", res.data.data.message);
            });
    };
};

export const selectFavoriteTeam = (favTeamObj, selectedTeam) => {
    return async (dispatch) => {
        dispatch(setRedeemRewardLoading(true));

        const newFavTeam = {
            teamId: selectedTeam.id,
            teamTriCode: selectedTeam.tricode.toUpperCase(),
            leagueId: "00",
            league: "NBA",
            favorited: true,
            followed: true
        };

        if (favTeamObj && favTeamObj.length > 0) {
            // a user can have multiple follows, but only one favorite team
            // check for previously favorited teams to unfavorite previous
            favTeamObj = structuredClone(favTeamObj);
            const prevFav = favTeamObj.findIndex((favTeam => favTeam.favorited));
            if (prevFav > -1) {
                favTeamObj[prevFav].favorited = false;
            }

            // check if selected team exists in current favorite team object
            const found = favTeamObj.findIndex((favTeam => favTeam.teamId === selectedTeam.teamId));
            if (found > -1) {
                favTeamObj.splice(found, 1, newFavTeam);
            } else {
                favTeamObj.push(newFavTeam);
            }
        } else {
            favTeamObj = [];
            favTeamObj.push(newFavTeam);
        }

        let body = { favoriteTeams: favTeamObj };
        const favTeamUrl = ENV === "prod" ? "https://identity.nba.com/api/v1/profile" : `https://identity-${ENV}.nba.com/${ENV}/profile`;

        axios.put(favTeamUrl, body, { withCredentials: true })
            .then((res) => {
                if (res && res.data) {
                    if (res.data.status === "success") {
                        dispatch(setFavoriteTeams(body.favoriteTeams));
                    } else if (res && res.data && res.data.status === "error" && res.data.data === "maintenance") {
                        doMaintenance();
                    } else if (res.data.status === "error") {
                        dispatch(setRedeemRewardLoading(false));
                        localStorage.setItem("selectFavTeamError", JSON.stringify(res.data));
                        console.log("status=error SELECT FAV TEAM", res.data);
                    }
                }
            })
            .catch((err) => {
                console.error("fav team response", err);
            });
    };
};
